import { captureException } from '@sentry/react';

export default async function emailLoader(): Promise<Response | null> {
  const promise = new Promise((resolve) => {
    try {
      const script = document.createElement('script');

      script.src = 'https://elements.stytch.com/telemetry.js';
      script.async = true;
      document.body.appendChild(script);
      script.addEventListener('load', function () {
        resolve(true);
      });
      script.onerror = () => {
        resolve(true);
      };
    } catch (error) {
      captureException(error);
      return null;
    }
  });
  await promise;
  return null;
}
